import Vue from "vue";
import * as Sentry from "@sentry/browser";
import { Integrations } from "@sentry/tracing";


if (process.env.NODE_ENV !== 'development') {
  console.log("Sentry init");
  Sentry.init({
    Vue,
    dsn: "https://0f752a5fee3642fbba06a7dd7b97a1c7@sentry.lphome.pw/2",
    autoSessionTracking: true,
    environment: process.env.VUE_APP_ENV,
    integrations: [
      new Integrations.BrowserTracing(),
    ],
    tracingOptions: {
      trackComponents: true,
    },
  
    // // We recommend adjusting this value in production, or using tracesSampler
    // // for finer control
    tracesSampleRate: 1.0,
  });
} else {
  console.log("[SENTRY] - Init skipped");
}